import { Component, inject, input, output, signal } from '@angular/core';
import { SuccessfulNotification } from '../../../../../utils/successful-notification/successful-notification';
import { Router } from '@angular/router';

@Component({
  selector: 'app-successful-creation-modal',
  imports: [SuccessfulNotification],
  templateUrl: './successful-creation-modal.html',
  styleUrl: './successful-creation-modal.scss',
})
export class SuccessfulCreationModal {
  private router = inject(Router);
  createdUser = input.required<{ firstName: string; lastName: string; username: string; password: string }>();
  showPassword = signal(false);
  isOpen = input.required<boolean>();
  closeModal = output<void>();
  isNotification = signal(false);

  onCloseModal() {
    this.closeModal.emit();
    this.router.navigate(['/admin/user-management']);
  }

  togglePasswordVisibility() {
    this.showPassword.set(!this.showPassword());
  }

  onCopyCredentials(): void {
    const { username, password } = this.createdUser();
    const textToCopy = `Username: ${username}\nPassword: ${password}`;

    if (navigator.clipboard && window.isSecureContext) {
      // Modern way — HTTPS only
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => this.showNotification())
        .catch((err) => console.error('Clipboard failed:', err));
    } else {
      // Fallback — works on HTTP too
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand('copy'); // deprecated but still works
        this.showNotification();
      } catch (err) {
        console.error('Fallback copy failed:', err);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  private showNotification(): void {
    this.isNotification.set(true);
    setTimeout(() => this.isNotification.set(false), 3000);
  }
}
